import { useMutation } from "@apollo/client/react";
import { SEND_DOCUMENT_REJECTION_EMAIL } from "../../mutations/documentHandler/sendDocumentRejectionEmail";

export const useSendDocumentRejectionEmail = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (result?: any) => void;
}) => {
  const [sendDocumentRejectionEmail, { data, loading, error }] = useMutation(
    SEND_DOCUMENT_REJECTION_EMAIL,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [],
      awaitRefetchQueries: true,
    }
  );

  return { sendDocumentRejectionEmail, data, loading, error };
};
